import { Box, Flex, Icon, Text, HStack, Badge, CloseButton } from '@chakra-ui/react';
import { NotificationItem } from '../../hooks/useGetNotifications';
import { getNotificationIcon, getNotificationMessage, getNotificationTag } from './NotificationRow';

interface NotificationToastProps {
    notification: NotificationItem;
    onClose: () => void;
    onClick: () => void;
}

const NotificationToast = ({ notification, onClose, onClick }: NotificationToastProps) => {
    const { icon, color, bg } = getNotificationIcon(notification.type);
    const tag = getNotificationTag(notification.type);

    return (
        <Box
            bg="white"
            border="1px solid"
            borderColor="gray.300"
            borderRadius="md"
            boxShadow="none"
            p={4}
            minW="320px"
            maxW="400px"
            cursor="pointer"
            onClick={onClick}
            _hover={{ boxShadow: 'none' }}
            transition="box-shadow 150ms ease"
        >
            <Flex gap={3} align="start">
                <Flex
                    w="36px"
                    h="36px"
                    borderRadius="full"
                    bg={bg}
                    align="center"
                    justify="center"
                    flexShrink={0}
                >
                    <Icon as={icon as React.ElementType} w={4} h={4} color={color} />
                </Flex>

                <Box flex={1} minW={0}>
                    <HStack spacing={2} align="center">
                        <Text
                            fontWeight="semibold"
                            fontSize="sm"
                            color="gray.800"
                        >
                            {getNotificationMessage(notification.type)}
                        </Text>
                        <Badge
                            fontSize="9px"
                            px={1.5}
                            py={0.5}
                            borderRadius="md"
                            bg={tag.bg}
                            color={tag.color}
                            fontWeight="medium"
                            textTransform="none"
                        >
                            {tag.label}
                        </Badge>
                    </HStack>
                    {notification.preview && (
                        <Text fontSize="xs" color="gray.500" mt={0.5} noOfLines={1}>
                            {notification.preview.vehicle}
                            {notification.preview.roNumber && ` • RO ${notification.preview.roNumber}`}
                        </Text>
                    )}
                </Box>

                <CloseButton
                    size="sm"
                    onClick={(e) => {
                        e.stopPropagation();
                        onClose();
                    }}
                    color="gray.400"
                    _hover={{ color: 'gray.600', bg: 'gray.100' }}
                />
            </Flex>
        </Box>
    );
};

export default NotificationToast;
